import cookieStorage from 'js-cookie';
import { compare, GroupingReporter } from 'dom-compare';

import { logging, icons, constants } from '@config';
import { addSafariFallbackListeners } from 'src/utils/safari';

import Extensions from '../extensions';
import initGestures from '../gestures';
import Modal from '../modal.js';
import Table from '../table/table';
import Text from '../text';
import initThumbs from '../thumb';
import {
  applyDimensionsFromElement,
  applyDimensionsFromBoxCoordinates,
  getDimensionsFromElement
} from '../utils/dimensions';
import videoInit, { addElement } from '../video';

import { initPageFactory, initAdvancedOrderedListFactory, initBulletListFactory } from './preload';

export default function loadComponents () {
  // TODO: gradually avoid using global namespace by requiring on each module
  INKIVE.disableWindowExitConfirm = INKIVE.C.IS_MOBILE_APP;
  INKIVE.C.DEBUG = logging.logLevelDebug;

  $(window).bind('beforeunload', function (e) {
    if (INKIVE.C.IS_AUTO_SAVE) {
      if (INKIVE.RestrictionsFactory && !INKIVE.RestrictionsFactory.isAllSaved()) {
        INKIVE.RestrictionsFactory.save();
      }

      INKIVE.EditorFacade.handle('page', 'save', { quiet: true });
    }

    if (!INKIVE.disableWindowExitConfirm && INKIVE.hasEditorUnsavedChanges) {
      const sureToLeave = INKIVE.TranslateHelper.translate(
        'modal.sure_to_leave'
      );
      e = e || window.event;
      if (e) e.returnValue = sureToLeave;
      return sureToLeave;
    }
  });

  $(window).bind('dragover drop', function (e) {
    $(e.target).is('input[type=file]') || e.preventDefault();
  });

  window.INKIVE.Tabs = {};

  initPageFactory();
  initTemplates();
  initModals();
  initUIComponents();
  initThumbs();
  const tool = initTools();
  initAdvancedOrderedListFactory();
  initBulletListFactory();
  initUndo();
  initWhiteLabel();
  initExtensions();
  initContextMenu();
  initIcons();
  initTable();
  initGestures();

  if (!INKIVE.C.IS_MOBILE_APP) {
    initToolsMenu();
    require('../utils/bootstrap-modals');
  }

  require('../analytics/error-track');

  window.INKIVE.Menus = {};

  window.INKIVE.DesignFacade = require('../facade/design/design');
  window.INKIVE.EditorFacade = require('../facade/editor/editor');
  window.INKIVE.EditorFacade.GraphemeSplitter = require('grapheme-splitter');
  window.INKIVE.ProjectFacade = require('../facade/project/project');
  window.INKIVE.RestrictionsFacade = require('../facade/restrictions/restrictions');

  window.INKIVE.DesignHandler = require('../facade/project/handlers/design');

  window.INKIVE.EditorModeManager = require('../ui/editor-mode-manager');

  window.INKIVE.SettingsFactory = require('../factory/settings');
  window.INKIVE.ImagesFactory = require('../factory/images');
  window.INKIVE.LibraryFactory = require('../factory/library').instance;
  window.INKIVE.UserInfoFactory = require('../factory/user-info');
  window.INKIVE.FontsFactory = require('../factory/fonts');
  window.INKIVE.TableOfContentsFactory = require('../factory/table-of-contents');
  window.INKIVE.TextOverflowFactory = require('../factory/text-overflow');
  window.INKIVE.AnimationFactory = require('../factory/animation');
  window.INKIVE.MediaFactory = require('../factory/media');
  window.INKIVE.FormatFactory = require('../factory/formats');
  window.INKIVE.FormatFactory.init();
  window.INKIVE.TinyColor = require('tinycolor2');

  window.INKIVE.DesygnerApi = require('../factory/desygner-api');

  initText();

  tool.editor.on('initialize', () => {
    INKIVE.FontsFactory.initialize().then(() => {
      (
        INKIVE.C.BOOK.book_type === INKIVE.C.BOOK_TYPE.RESTRICTED_DESIGN
          ? INKIVE.RestrictionsFacade.initialize()
          : $.Deferred().resolve()
      ).then(() => {
        INKIVE.C.IS_MOBILE_APP && AppBridge.callBoth('editor_loaded', { book_id: INKIVE.C.BOOK.id });
        INKIVE.History.enableSystem();
        INKIVE.EditorFacade.trigger('editor.loaded');
        initPrintingGuidelines(tool);
      });
    });
  });

  if (!INKIVE.C.IS_MOBILE_APP) {
    INKIVE.DesignFacade.on('background.update', function () {
      $('.popupmenu').remove();
    });

    INKIVE.DesignFacade.on('background.update.color', function () {
      tool.editor.canvas.runExtensions('showBackgroundPopupMenu', {});
    });
  }

  const importFontsEvents = ['sticker.create', 'sticker.update', 'text.create', 'text.update.font', 'template.update.restricted'];

  _.each(importFontsEvents, function (event) {
    INKIVE.DesignFacade.on(event, function () {
      INKIVE.FontsFactory.importDesignCSSFonts();
    });
  });

  INKIVE.EditorFacade.on('page.move_to', function () {
    try {
      INKIVE.FontsFactory.importDesignCSSFonts();
    } catch (error) {
      INKIVE.FontsFactory.initialize()
        .then(() => INKIVE.FontsFactory.importDesignCSSFonts());
    }
  });

  INKIVE.EditorFacade.on('page.load_version', function () {
    try {
      INKIVE.FontsFactory.importDesignCSSFonts();
    } catch (error) {
      INKIVE.FontsFactory.initialize()
        .then(() => INKIVE.FontsFactory.importDesignCSSFonts());
    }
  });

  INKIVE.EditorFacade.on('editor.loaded', async () => {
    initPrint();
    initTranslations();
    initTableOfContentsFactory();
    initTextOverflowFactory();
    initAnimationFactory();
    initMediaFactory();
    await initConfigKeys();

    checkNewEditorRollout();
  });

  INKIVE.C.USER.email || INKIVE.UserInfoFactory.get().then(function (user) {
    INKIVE.C.USER.nickname = Base64.encode(user.nickname);
    INKIVE.C.USER.email = Base64.encode(user.email);
  });

  initAnimationView();

  const ElementPopupmenuView = require('../ui/element-popupmenu/view');
  window.INKIVE.Menus.elementPopupMenu = new ElementPopupmenuView({ el: '#element-popupmenu' });
  require('../utils/translate-constants')(window.INKIVE.TranslateHelper.translate);

  const TopSubmenuView = require('../ui/top-submenu/view');

  if (!INKIVE.C.IS_MOBILE_APP) {
    window.INKIVE.Menus.TopSubmenuView = new TopSubmenuView({ el: 'body > header' });
  }
  if (!INKIVE.Helpers.isDesygnerProject() && INKIVE.C.WHITE_LABEL_CONFIGURATION.name) {
    window.original = INKIVE.C.WHITE_LABEL_CONFIGURATION.name;
    document.title = window.original;
    replaceFavicon();
  } else if (INKIVE.C.BOOK.book_type === INKIVE.C.BOOK_TYPE.RESTRICTED_DESIGN) {
    document.title = INKIVE.TranslateHelper.translate('common.webrand_design_title');
  } else if (INKIVE.C.BOOK.book_type === INKIVE.C.BOOK_TYPE.TEMPLATE) {
    document.title = INKIVE.TranslateHelper.translate('common.webrand_template_title');
  } else {
    document.title = 'Desygner';
  }

  attachProjectNameToTitle();

  /** TODO: Remove this function when Safari fixes the bug.
   * This is a temporary solution for a Safari bug.
   * https://desygner-team.slack.com/archives/C01KD2D15C1/p1672987247327579
   */
  addSafariFallbackListeners();
}

function attachProjectNameToTitle () {
  try {
    const projectName = document.querySelector('div[data-value="project-name"] > span').textContent;
    document.title = `${document.title} | ${projectName}`;
    window.original = document.title;
  } catch (e) { }
}

function replaceFavicon () {
  document.querySelectorAll("link[rel*='icon']").forEach(icon => {
    icon.href = INKIVE.C.WHITE_LABEL_CONFIGURATION.logo_url;
  });
}

function initAnimationView () {
  const AnimationView = require('../ui/tool-menu/animation/view');

  if (INKIVE.C.IS_MOBILE) {
    // Manually create entry point on mobile
    const el = document.createElement('div');
    el.setAttribute('role', 'tabpanel');
    el.setAttribute('class', 'tab');
    el.setAttribute('id', 'tabAnimation');
    document.body.append(el);
  }
  window.INKIVE.Tabs.animation = new AnimationView({ el: '#tabAnimation' });
  window.INKIVE.Tabs.animation.show();
}

function initExtensions () {
  window.INKIVE.EXTENSION = Extensions;
}

function initUndo () {
  const designFacade = require('../facade/design/design');
  const editorFacade = require('../facade/editor/editor');
  INKIVE.History = require('../core/history/history');
  // Used by history to compare snapshots and extract differences (to perform undo/redo)
  INKIVE.DomCompareTools = { compare, groupingReporter: GroupingReporter };

  let eventsList = [
    'image.update', 'image.create.source.url', 'image.filter', 'image.replace', 'image.update.source.url',
    'image.dropped', 'image.flip_vertical', 'image.flip_horizontal', 'flipped_image',
    'background.update', 'background.update.source.loaded', 'background.update.color',
    'background.flip_vertical', 'background.flip_horizontal',
    'group.create', 'group.update', 'group.ungroup',
    'shape.create', 'shape.update', 'shape.flip_vertical', 'shape.flip_horizontal',
    'sticker.create', 'sticker.update', 'sticker.explode', 'sticker.flip_horizontal', 'sticker.flip_vertical',
    'logo.create', 'logo.update',
    'icon.create', 'icon.update',
    'text.create', 'text.update',
    'video.create', 'video.update',
    'table.create', 'table.update',
    'link.update', 'placeholder.update',
    'move', 'rotate', 'resize', 'delete', 'duplicate', 'draw', 'cut', 'paste',
    'send_forward', 'send_backward', 'send_top', 'send_bottom',
    'template.update.template_applied_on_current_page', 'template.update.restricted', 'template.update.size'
  ];

  _.each(eventsList, function (eventName) {
    designFacade.on(eventName, _.partial(onEvent, 'design.' + eventName));
  });

  designFacade.on('template.update.grid', reload);

  editorFacade.on('page.move_to', function () {
    editorFacade.once('page.converted', reload);
  });

  editorFacade.on('page.load_version', function () {
    editorFacade.once('page.converted', function () {
      onEvent('editor.page.converted');
    });
  });

  eventsList = ['image.crop.end', 'background.crop.end', 'video.crop.end', 'convert_to_image_box', 'align', 'distribute'];
  _.each(eventsList, function (eventName) {
    editorFacade.on(eventName, _.partial(onEvent, 'editor.' + eventName));
  });

  function onEvent (eventName, eventData, additionData) {
    if (!INKIVE.History.isSystemEnabled()) return;

    const tool = INKIVE.Tool.getInstance();
    const skip = eventData?.skipHistory || additionData?.skipHistory;

    skip || INKIVE.History.onChange(eventName, eventData, {
      svg: tool.editor.getSvgString(),
      textMock: tool.editor.getSvgString(document.getElementById('textmock')),
      hiddenContent: INKIVE.Text.Helpers.hiddenContent
    });
  }

  function reload () {
    const tool = INKIVE.Tool.getInstance();
    INKIVE.History.reload({
      svg: tool.editor.getSvgString(),
      textMock: tool.editor.getSvgString(document.getElementById('textmock')),
      hiddenContent: {}
    });
  }
}

function initToolsMenu () {
  require('../ui/tool-menu/element-options');
  const ImagesView = require('../ui/tool-menu/images/view');
  const TextView = require('../ui/tool-menu/text/view');
  const IconsView = require('../ui/tool-menu/icons/view');
  const LogosView = require('../ui/tool-menu/logos/view');
  const QRCodeView = require('../ui/tool-menu/qrcode/view');
  const VideosView = require('../ui/tool-menu/videos/view');
  const TemplatesView = require('../ui/tool-menu/templates/view');
  const AdminView = require('../ui/tool-menu/admin/view');
  const SearchView = require('../ui/tool-menu/search/view');
  const AnimationView = require('../ui/tool-menu/animation/view');

  window.INKIVE.Tabs.images = new ImagesView({ el: '#tabImages' });
  window.INKIVE.Tabs.text = new TextView({ el: '#tabText' });
  window.INKIVE.Tabs.icons = new IconsView({ el: '#tabIcons' });
  window.INKIVE.Tabs.logos = new LogosView({ el: '#tabLogos' });
  window.INKIVE.Tabs.qrcode = new QRCodeView({ el: '#tabQRCode' });
  window.INKIVE.Tabs.video = new VideosView({ el: '#tabVideo' });
  window.INKIVE.Tabs.admin = new AdminView({ el: '#tabAdmin' });
  window.INKIVE.Tabs.layouts = new TemplatesView({ el: '#tabLayouts' });
  window.INKIVE.Tabs.search = new SearchView({ el: '#tabSearch' });
  window.INKIVE.Tabs.animation = new AnimationView({ el: '#tabAnimation' });

  if ($('#tabPlaceholders').length) {
    const PlaceholdersView = require('../ui/tool-menu/placeholders/view');
    window.INKIVE.Tabs.placeholders = new PlaceholdersView({ el: '#tabPlaceholders' });
    window.INKIVE.PlaceholdersFactory = require('../factory/placeholders');
  }

  if ($('#tabRestrictions').length) {
    window.INKIVE.RestrictionsFactory = require('../factory/restrictions');

    INKIVE.RestrictionsFactory.initialize().then(() => {
      if (INKIVE.Menus.showSimplifiedRestrictions) {
        const SimplifiedRestrictionsView = require('../ui/tool-menu/simplified-restrictions/view');
        window.INKIVE.Tabs.simplifiedrestrictions = new SimplifiedRestrictionsView(
          { el: '#tabSimplifiedRestrictions' });
      } else {
        const RestrictionsView = require('../ui/tool-menu/restrictions/view');

        window.INKIVE.Tabs.restrictions = new RestrictionsView({ el: '#tabRestrictions' });
      }
    });
  }

  if ($('#tabRestricted').length) {
    const RestrictedView = require('../ui/tool-menu/restricted/view');
    window.INKIVE.Tabs.restricted = new RestrictedView({ el: '#tabRestricted' });
  }

  if ($('#tabKWLS').length) {
    const KWLSView = require('../ui/tool-menu/kwls/view');
    window.INKIVE.Tabs.kwls = new KWLSView({ el: '#tabKWLS' });
  }

  if ($('#tabMLS').length) {
    const MLSView = require('../ui/tool-menu/mls/view');
    window.INKIVE.Tabs.mls = new MLSView({ el: '#tabMLS' });
  }

  if ($('#tabRedfin').length) {
    const RedfinView = require('../ui/tool-menu/redfin/view');
    window.INKIVE.Tabs.redfin = new RedfinView({ el: '#tabRedfin' });
  }
}

function initTools () {
  window.INKIVE.Tool = window.INKIVE.Tool || {};
  window.INKIVE.Helpers = window.INKIVE.Helpers || {};

  window.INKIVE.Helpers.getStickerFromString = require('../svg-importer/import');
  window.INKIVE.Helpers.applyDimensionsFromElement = applyDimensionsFromElement;
  window.INKIVE.Helpers.applyDimensionsFromBoxCoordinates = applyDimensionsFromBoxCoordinates;
  window.INKIVE.Helpers.getDimensionsFromElement = getDimensionsFromElement;
  window.INKIVE.Helpers.cookieStorage = require('../utils/cookie-storage');
  window.INKIVE.Helpers.elementHelper = require('../../helpers/element').default;
  window.INKIVE.Helpers.imagesSanitize = require('../utils/images-sanitize');
  window.INKIVE.Helpers.DownloadProcedure = require('../ui/top-submenu/contents/download/download-procedure');
  window.INKIVE.Helpers.DownloadProcedure.initialize();

  window.INKIVE.SVGElementLoading = require('../SVGElementLoading');

  if (INKIVE.C.IS_MOBILE_APP || INKIVE.C.IS_MOBILE) {
    window.AppBridge = require('../app/bridge');
  }

  require('../utils/ellipsis')();
  require('../utils/backbone-mixin');

  const tool = INKIVE.Tool.getInstance();
  tool.editor.on('initialize', function () {
    const advice = require('../utils/advice');
    advice.initialize(tool.editor.canvas);
    videoInit(tool.editor.canvas);
    window.INKIVE.Video = { addElement };
  });

  return tool;
}

function initModals () {
  window.INKIVE.Modal = new Modal();
  window.INKIVE.ModalHelp = require('../modal/help');
  window.INKIVE.ModalAddPage = require('../modal/add-page');
  window.INKIVE.ModalShareEmail = require('../modal/share-email');
  window.INKIVE.ModalShareEmbed = require('../modal/share-embed');
  window.INKIVE.ModalFriends = require('../modal/friends');
  window.INKIVE.ModalDownload = require('../modal/download');
  window.INKIVE.ModalAdminBackground = require('../modal/admin-background.js');
  window.INKIVE.ModalAdminSticker = require('../modal/admin-sticker.js');
  window.INKIVE.ModalAdminLayout = require('../modal/admin-layout.js');
}

function initUIComponents () {
  require('../ui/filterpicker');
  require('../ui/colors/colorpicker');

  const isDnDEnabled = INKIVE.C.MODE.IS_DESYGNER && !INKIVE.C.IS_MOBILE;
  const StageDragAndDrop = require('../ui/stage-dnd');
  isDnDEnabled && StageDragAndDrop.init();

  window.INKIVE.PopupMenuDefault = require('../ui/element-popupmenu/popupmenuDefault').default;
  window.INKIVE.PopupMenuMobile = require('../ui/element-popupmenu/popupmenuMobile').default;
  require('../ui/element-popupmenu/popupmenu').default(window.jQuery);
}

function initTemplates () {
  window.INKIVE.TemplatesHelper = require('../ui/templates/templates-helper');
}

function initTableOfContentsFactory () {
  INKIVE.TableOfContentsFactory.init();
}

function initTextOverflowFactory () {
  INKIVE.TextOverflowFactory.init();
}

function initAnimationFactory () {
  INKIVE.AnimationFactory.init();
}

function initMediaFactory () {
  INKIVE.MediaFactory.init();
}

function initWhiteLabel () {
  const whiteLabelFactory = require('../factory/white-label');

  whiteLabelFactory.apply();
}

async function initTranslations () {
  INKIVE.C.TRANSLATION_DATA && INKIVE.EditorFacade.handle(
    'translations', 'display', INKIVE.C.TRANSLATION_DATA
  );
}

function initPrint () {
  const companyFactory = require('../factory/company').instance;
  const projectPromise = companyFactory.getProjectData();
  const featuresPromise = companyFactory.getCompanyItems('features');
  window.INKIVE.CompanyFactory = companyFactory;

  const printBtn = document.querySelector('.options button[data-action="order-print"]');

  Promise.all([featuresPromise, projectPromise]).then(([features, companyData]) => {
    const hasProfessionalPrint = features?.my_designs?.includes('professional_print');

    hasProfessionalPrint || printBtn?.classList.add('hidden');
    if (hasProfessionalPrint) {
      let hide;

      if (companyData.is_printable) {
        hide = !INKIVE.RestrictionsFacade.isFunctionalityAllowed('function_print_file');
        !hide && /(^|&|#|\?)print($|&)/.test(document.location.search) &&
          INKIVE.EditorFacade.handle('printing', 'open');
      } else {
        isEnterprise = INKIVE.C.WHITE_LABEL_CONFIGURATION.subscription_plan === 'enterprise';
        isDesygner = companyData?.company?.domain === 'desygner';
        hide = (isEnterprise && !isDesygner) ||
          INKIVE.C.BOOK.book_type === INKIVE.C.BOOK_TYPE.RESTRICTED_DESIGN;
      }

      printBtn && printBtn.classList[hide ? 'add' : 'remove']('hidden');
    }

    INKIVE.Tabs.restrictions && INKIVE.Tabs.restrictions.on('template-restrictions-updated', () => {
      hasProfessionalPrint || $('#tabRestrictions input[name=function_print_file]').closest('li').hide();
    });
  });
}

function initContextMenu () {
  window.INKIVE.ContextMenu = require('../ui/context-menu');
}

function initIcons () {
  fetch(icons.url)
    .then((response) => response.text())
    .then((iconsXML) => {
      const container = document.createElement('div');
      document.body && document.body.appendChild(container);
      container.style.display = 'none';
      container.innerHTML = iconsXML;
    });
}

function initTable () {
  INKIVE.Table = new Table();
}

function initText () {
  INKIVE.Text = Text();
}

async function initPrintingGuidelines (tool) {
  await INKIVE.FormatFactory.getCurrentFormat();
  const printType = INKIVE.Helpers.getPrintGuidelinesProject();

  if (!printType) {
    return;
  }

  const type = constants.printingTypes[printType];

  type.showBleed && (function waitForSvgContent () {
    if (document.querySelector('#svgcontent .main')) {
      tool.editor.canvas.runExtensions('showSafeArea');
      INKIVE.EditorFacade.handle('printing', 'toggle_bleed', { show: true, manage: false });
    } else {
      setTimeout(waitForSvgContent, 500);
    }
  })();
  type.img && INKIVE.EditorFacade.handle('printing_mode', 'set_stationary_item_mode');
}

function initConfigKeys () {
  CONFIG.white_label_configuration = INKIVE.C.WHITE_LABEL_CONFIGURATION;

  const companyFactory = require('../factory/company').instance;
  const featuresPromise = companyFactory.getCompanyItems('features');
  const addonsPromise = companyFactory.getCompanyItems('add_ons');

  return Promise.all([featuresPromise, addonsPromise]).then(([features, addons]) => {
    CONFIG.features = INKIVE.C.FEATURE_FLAG = features;
    CONFIG.addons = INKIVE.C.ADDONS || mapAddons(addons, features);
  });
}

function mapAddons (addons = [], features = {}) {
  const mapped = {};

  addons.forEach(addon => {
    mapped[addon] = {
      id: addon
    };

    if (features[addon]) {
      mapped[addon].features = features[addon];
    }
  });

  return mapped;
}

async function checkNewEditorRollout () {
  try {
    if (INKIVE.C.IS_MOBILE_APP) return;

    if (CONFIG.addons.new_editor_roll_out) {
      const forceFullRollout = CONFIG.addons.new_editor_roll_out.features.includes('force_all_in_new_editor');
      if (forceFullRollout) return redirectToNewEditor();

      const forceMemberRollout = CONFIG.addons.new_editor_roll_out.features.includes('force_use_in_new_editor_only');
      const isAdmin = await INKIVE.UserInfoFactory.isAdmin();

      if (forceMemberRollout && !isAdmin) {
        return redirectToNewEditor();
      }
    }
  } catch (error) {
    console.error('Failed to redirect user to new Editor', error);
  }

  INKIVE.EditorFacade.trigger('switchEditorModal.show');
}

function redirectToNewEditor () {
  cookieStorage.set('editor_preference', 'fluer');

  window.location.reload();
}
